export default __webpack_public_path__ + "static/media/icon-shopping.36c4bd3e.svg";